import createHeaders from "@utils/createHeaders";

export const headers = createHeaders ([
  { text: 'No', value: 'number_index', width: '10' },
  { text: 'Bulan', value: 'month' },
  { text: 'File Name', value: 'filename', width: '300' },
  { text: 'Created Date', value: 'last_update_date' },
  { text: 'Action', value: 'action', align: 'center', textAlign: 'text-center' },
]);

export const search = {
  last_update_date: [],
};
